import headerImg from "assets/images/v144/header.webp"
import infoImg from "assets/images/v144/info.webp"

export const v144Config = {
  header: {
    en: headerImg,
  },
  info: {
    en: infoImg,
  },
}
